import React from "react";

const ManagerPanelIcons = ({
  className,
  d,
  transform,
  done,
  transformone,
  fillcolor,
  fill,
  dtwo,
  transformtwo,
  width,
  height,
  viewBox,
  cx,
  cy,
  r,
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
    >
      <g fill={fill} fillRule="evenodd">
        <g transform="translate(-728 -218) translate(109 169) translate(619 49)">
          <circle cx={cx} cy={cy} r={r} fill={fillcolor} />

          <path d={d} transform={transform} />
          <g strokeLinecap="round" strokeLinejoin="round" strokeWidth=".77">
            <g>
              <path stroke="#f8f8f8" d={done} transform={transformone} />
              <path stroke="#f8f8f8" d={dtwo} transform={transformtwo} />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ManagerPanelIcons;
